const SMALL = 'small';
const LARGE = 'large';

const TOP_DESTINATIONS = [
    {
        id: 'Dubai',
        title: 'TopDestinations.Dubai',
        sub_title: 'TopDestinations.Dubai_Subtitle',
        image: 'leisure_destinations/dubai.jpg',
        destination: {
            "address": "Dubai - United Arab Emirates",
            "place": {
                "description": "Dubai - United Arab Emirates",
                "place_id": "ChIJRcbZaklDXz4RYlEphFBu5r0",
                "reference": "ChIJRcbZaklDXz4RYlEphFBu5r0",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "Dubai",
                "label": "Dubai, United Arab Emirates",
                "address": "Dubai - United Arab Emirates",
                "short_address": "United Arab Emirates",
                "index": -1,
                "address_components": [
                    {
                        "long_name": "Dubai",
                        "short_name": "Dubai",
                        "types": [
                            "locality",
                            "political"
                        ]
                    },
                    {
                        "long_name": "Dubai",
                        "short_name": "Dubai",
                        "types": [
                            "administrative_area_level_1",
                            "political"
                        ]
                    },
                    {
                        "long_name": "United Arab Emirates",
                        "short_name": "AE",
                        "types": [
                            "country",
                            "political"
                        ]
                    }
                ],
                "formatted_address": "Dubai - United Arab Emirates",
                "geometry": {
                    "location": {
                        "lat": 25.2048493,
                        "lng": 55.2707828
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 25.35856066265986,
                            "lng": 55.5650392624228
                        },
                        "southwest": {
                            "lat": 24.79348418590246,
                            "lng": 54.89045432509004
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 25.2048493,
                    "lng": 55.2707828
                },
                "viewport": {
                    "northeast": {
                        "lat": 25.35856066265986,
                        "lng": 55.5650392624228
                    },
                    "southwest": {
                        "lat": 24.79348418590246,
                        "lng": 54.89045432509004
                    }
                }
            }
        },
        type: SMALL
    },
    {
        id: 'NewYork',
        title: 'TopDestinations.NewYork',
        sub_title: 'TopDestinations.NewYork_Subtitle',
        image: 'leisure_destinations/new-york.jpg',
        destination: {
            "address": "New York, NY, USA",
            "place": {
                "description": "New York, NY, USA",
                "place_id": "ChIJOwg_06VPwokRYv534QaPC8g",
                "reference": "ChIJOwg_06VPwokRYv534QaPC8g",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "New York",
                "label": "New York, NY, USA",
                "address": "New York, NY, USA",
                "short_address": "NY, USA",
                "index": -1,
                "address_components": [
                    {
                        "long_name": "New York",
                        "short_name": "New York",
                        "types": [
                            "locality",
                            "political"
                        ]
                    },
                    {
                        "long_name": "New York",
                        "short_name": "NY",
                        "types": [
                            "administrative_area_level_1",
                            "political"
                        ]
                    },
                    {
                        "long_name": "United States",
                        "short_name": "US",
                        "types": [
                            "country",
                            "political"
                        ]
                    }
                ],
                "formatted_address": "New York, NY, USA",
                "geometry": {
                    "location": {
                        "lat": 40.7127753,
                        "lng": -74.0059728
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 40.91757705070789,
                            "lng": -73.70027206817629
                        },
                        "southwest": {
                            "lat": 40.47739906045452,
                            "lng": -74.25908991427882
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 40.7127753,
                    "lng": -74.0059728
                },
                "viewport": {
                    "northeast": {
                        "lat": 40.91757705070789,
                        "lng": -73.70027206817629
                    },
                    "southwest": {
                        "lat": 40.47739906045452,
                        "lng": -74.25908991427882
                    }
                }
            }
        },
        type: SMALL
    },
    {
        id: 'London',
        title: 'TopDestinations.London',
        sub_title: 'TopDestinations.Subtitle3',
        image: 'leisure_destinations/london.jpg',
        destination: {
            "address": "London, UK",
            "place": {
                "description": "London, UK",
                "place_id": "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                "reference": "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "London",
                "label": "London, UK",
                "address": "London, UK",
                "short_address": "UK",
                "index": -1,
                "address_components": [
                    {
                        "long_name": "London",
                        "short_name": "London",
                        "types": [
                            "locality",
                            "political"
                        ]
                    },
                    {
                        "long_name": "London",
                        "short_name": "London",
                        "types": [
                            "postal_town"
                        ]
                    },
                    {
                        "long_name": "Greater London",
                        "short_name": "Greater London",
                        "types": [
                            "administrative_area_level_2",
                            "political"
                        ]
                    },
                    {
                        "long_name": "England",
                        "short_name": "England",
                        "types": [
                            "administrative_area_level_1",
                            "political"
                        ]
                    },
                    {
                        "long_name": "United Kingdom",
                        "short_name": "GB",
                        "types": [
                            "country",
                            "political"
                        ]
                    }
                ],
                "formatted_address": "London, UK",
                "geometry": {
                    "location": {
                        "lat": 51.5072178,
                        "lng": -0.1275862
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 51.67234324898703,
                            "lng": 0.1482710335611201
                        },
                        "southwest": {
                            "lat": 51.38494012429096,
                            "lng": -0.3514683384218145
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 51.5072178,
                    "lng": -0.1275862
                },
                "viewport": {
                    "northeast": {
                        "lat": 51.67234324898703,
                        "lng": 0.1482710335611201
                    },
                    "southwest": {
                        "lat": 51.38494012429096,
                        "lng": -0.3514683384218145
                    }
                }
            }
        },
        type: LARGE
    }
];

const EXTENDED_TOP_DESTINATIONS = [
    {
        id: 'NewYork',
        title: 'TopDestinations.NewYork',
        sub_title: 'TopDestinations.NewYork_Subtitle',
        image: 'leisure_destinations/new-york.png',
        destination: {
            "address": "New York, NY, USA",
            "place": {
                "description": "New York, NY, USA",
                "place_id": "ChIJOwg_06VPwokRYv534QaPC8g",
                "reference": "ChIJOwg_06VPwokRYv534QaPC8g",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "New York",
                "label": "New York, NY, USA",
                "address": "New York, NY, USA",
                "short_address": "NY, USA",
                "index": -1,
                "address_components": [
                    {
                        "long_name": "New York",
                        "short_name": "New York",
                        "types": [
                            "locality",
                            "political"
                        ]
                    },
                    {
                        "long_name": "New York",
                        "short_name": "NY",
                        "types": [
                            "administrative_area_level_1",
                            "political"
                        ]
                    },
                    {
                        "long_name": "United States",
                        "short_name": "US",
                        "types": [
                            "country",
                            "political"
                        ]
                    }
                ],
                "formatted_address": "New York, NY, USA",
                "geometry": {
                    "location": {
                        "lat": 40.7127753,
                        "lng": -74.0059728
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 40.91757705070789,
                            "lng": -73.70027206817629
                        },
                        "southwest": {
                            "lat": 40.47739906045452,
                            "lng": -74.25908991427882
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 40.7127753,
                    "lng": -74.0059728
                },
                "viewport": {
                    "northeast": {
                        "lat": 40.91757705070789,
                        "lng": -73.70027206817629
                    },
                    "southwest": {
                        "lat": 40.47739906045452,
                        "lng": -74.25908991427882
                    }
                }
            }
        },
        type: SMALL
    },
    {
        id: 'Athens',
        title: 'TopDestinations.Athens',
        sub_title: 'TopDestinations.Athens_Subtitle',
        image: 'leisure_destinations/athens.png',
        destination: {
            "address": "Athens, Greece",
            "place": {
                "description": "Athens, Greece",
                "place_id": "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",
                "reference": "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "Athens",
                "label": "Athens, Greece",
                "address": "Athens, Greece",
                "short_address": "Greece",
                "index": -1,
                "address_components": [{
                    "long_name": "Athens",
                    "short_name": "Athens",
                    "types": ["locality", "political"]
                }, {
                    "long_name": "Central Athens Regional Unit",
                    "short_name": "Central Athens Regional Unit",
                    "types": ["administrative_area_level_3", "political"]
                }, {
                    "long_name": "Greece",
                    "short_name": "GR",
                    "types": ["country", "political"]
                }],
                "formatted_address": "Athens, Greece",
                "geometry": {
                    "location": {
                        "lat": 37.9838096,
                        "lng": 23.7275388
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 38.03285634274878,
                            "lng": 23.7896925212467
                        },
                        "southwest": {
                            "lat": 37.94881814647892,
                            "lng": 23.68698615988247
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 37.9838096,
                    "lng": 23.7275388
                },
                "viewport": {
                    "northeast": {
                        "lat": 38.03285634274878,
                        "lng": 23.7896925212467
                    },
                    "southwest": {
                        "lat": 37.94881814647892,
                        "lng": 23.68698615988247
                    }
                }
            }
        },
        type: SMALL
    },
    {
        id: 'Dubai',
        title: 'TopDestinations.Dubai',
        sub_title: 'TopDestinations.Dubai_Subtitle',
        image: 'leisure_destinations/dubai.png',
        destination: {
            "address": "Dubai, United Arab Emirates",
            "place": {
                "description": "Dubai, United Arab Emirates",
                "place_id": "ChIJRcbZaklDXz4RYlEphFBu5r0",
                "reference": "ChIJRcbZaklDXz4RYlEphFBu5r0",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "Dubai",
                "label": "Dubai, United Arab Emirates",
                "address": "Dubai, United Arab Emirates",
                "short_address": "Dubai",
                "index": -1,
                "address_components": [{
                    long_name: "Dubai",
                    short_name: "Dubai",
                    types: ["locality", "political"]
                }, {
                    long_name: "Dubai",
                    short_name: "Dubai",
                    types: ["administrative_area_level_1", "political"]
                }, {
                    long_name: "United Arab Emirates",
                    short_name: "AE",
                    types: ["country", "political"]
                }],
                "formatted_address": "Dubai - United Arab Emirates",
                "geometry": {
                    "location": {
                        "lat": 25.2048493,
                        "lng": 55.2707828
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 25.35856066265986,
                            "lng": 55.56452157241026
                        },
                        "southwest": {
                            "lat": 24.79348418590246,
                            "lng": 54.89045432509004
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 25.2048493,
                    "lng": 55.2707828
                },
                "viewport": {
                    "northeast": {
                        "lat": 25.35856066265986,
                        "lng": 55.56452157241026
                    },
                    "southwest": {
                        "lat": 24.79348418590246,

                        "lng": 54.89045432509004
                    }
                }
            }
        },
        type: SMALL
    },
    {
        id: 'KohSamui',
        title: 'TopDestinations.KohSamui',
        sub_title: 'TopDestinations.KohSamui_Subtitle',
        image: 'leisure_destinations/koh-samui.png',
        destination: {
            "address": "Koh Samui, Thailand",
            "place": {
                "description": "Koh Samui, Ko Samui District, Surat Thani, Thailand",
                "place_id": "ChIJcyZmHFDxVDAR0IA2LLwjAgM",
                "reference": "ChIJcyZmHFDxVDAR0IA2LLwjAgM",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "Koh Samui",
                "label": "Koh Samui, Thailand",
                "address": "Koh Samui, Thailand",
                "short_address": "Koh Samui",
                "index": -1,
                "address_components": [{
                    long_name: "Koh Samui",
                    short_name: "Koh Samui",
                    types: ["locality", "political"]
                }, {
                    long_name: "Ko Samui District",
                    short_name: "Ko Samui District",
                    types: ["administrative_area_level_2", "political"]
                }, {
                    long_name: "Surat Thani",
                    short_name: "จ.สุราษฎร์ธานี",
                    types: ["administrative_area_level_1", "political"]
                }, {
                    long_name: "Thailand",
                    short_name: "TH",
                    types: ["country", "political"]
                }],
                "formatted_address": "Koh Samui, Ko Samui District, Surat Thani, Thailand",
                "geometry": {
                    "location": {
                        "lat": 9.5214157,
                        "lng": 100.0482144
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 9.801232439702698,
                            "lng": 100.0906548371837
                        },
                        "southwest": {
                            "lat": 9.300729270441792,
                            "lng": 99.65013441956222
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 9.5214157,
                    "lng": 100.0482144
                },
                "viewport": {
                    "northeast": {
                        "lat": 9.801232439702698,
                        "lng": 100.0906548371837
                    },
                    "southwest": {
                        "lat": 9.300729270441792,
                        "lng": 99.65013441956222
                    }
                }
            }
        },
        type: SMALL
    },
    {
        id: 'Budapest',
        title: 'TopDestinations.Budapest',
        sub_title: 'TopDestinations.Budapest_Subtitle',
        image: 'leisure_destinations/budapest.png',
        destination: {
            "address": "Budapest, Hungary",
            "place": {
                "description": "Budapest, Hungary",
                "place_id": "ChIJyc_U0TTDQUcRYBEeDCnEAAQ",
                "reference": "ChIJyc_U0TTDQUcRYBEeDCnEAAQ",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "Budapest",
                "label": "Budapest, Hungary",
                "address": "Budapest, Hungary",
                "short_address": "Hungary",
                "index": -1,
                "address_components": [{
                    long_name: "Budapest",
                    short_name: "Budapest",
                    types: ["locality", "political"]
                }, {
                    long_name: "Hungary",
                    short_name: "HU",
                    types: ["country", "political"]
                }],
                "formatted_address": "Budapest, Hungary",
                "geometry": {
                    "location": {
                        "lat": 47.497912,
                        "lng": 19.040235
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 47.61301194615275,
                            "lng": 19.33450493254384
                        },
                        "southwest": {
                            "lat": 47.34941504569791,
                            "lng": 18.92610106630945
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 47.497912,
                    "lng": 19.040235
                },
                "viewport": {
                    "northeast": {
                        "lat": 47.61301194615275,
                        "lng": 19.33450493254384
                    },
                    "southwest": {
                        "lat": 47.34941504569791,
                        "lng": 18.92610106630945
                    }
                }
            }
        },
        type: SMALL
    },
    {
        id: 'Rhodes',
        title: 'TopDestinations.Rhodes',
        sub_title: 'TopDestinations.Rhodes_Subtitle',
        image: 'leisure_destinations/rhodes.png',
        destination: {
            "address": "Rhodes, Greece",
            "place": {
                "description": "Rhodes, Greece",
                "place_id": "ChIJYf8K4ZNhlRQRk4i_vYjQE2k",
                "reference": "ChIJYf8K4ZNhlRQRk4i_vYjQE2k",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "Rhodes",
                "label": "Rhodes, Greece",
                "address": "Rhodes, Greece",
                "short_address": "Greece",
                "index": -1,
                "address_components": [{
                    long_name: "Rhodes",
                    short_name: "Rhodes",
                    types: ["locality", "political"]
                }, {
                    long_name: "Rhodes",
                    short_name: "Rhodes",
                    types: ["administrative_area_level_3", "political"]
                }, {
                    long_name: "Greece",
                    short_name: "GR",
                    types: ["country", "political"]
                }],
                "formatted_address": "Rhodes, Greece",
                "geometry": {
                    "location": {
                        "lat": 36.4359325,
                        "lng": 28.2172676
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 36.4586052237461,
                            "lng": 28.24081820191253
                        },
                        "southwest": {
                            "lat": 36.41289633176704,
                            "lng": 28.20258754462017
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 36.4359325,
                    "lng": 28.2172676
                },
                "viewport": {
                    "northeast": {
                        "lat": 36.4586052237461,
                        "lng": 28.24081820191253
                    },
                    "southwest": {
                        "lat": 36.41289633176704,
                        "lng": 28.20258754462017
                    }
                }
            }
        },
        type: SMALL
    },
]

module.exports = {
    SMALL,
    LARGE,
    TOP_DESTINATIONS,
    EXTENDED_TOP_DESTINATIONS
}
